'use strict';

const SoaCollection = require('bunsen/collections/SoaCollection');

const RecommendationItem = require('bunsen/models/identity/RecommendationItem');
const endpoints = require('dibs-endpoints');

const RecommendationItems = SoaCollection.extend({
    url: endpoints.recommendations(),
    model : RecommendationItem
});

module.exports = RecommendationItems;



// WEBPACK FOOTER //
// ./~/bunsen/collections/identity/RecommendationItems.es.js